import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { fmtTL, fmtDate } from "@/lib/format";
import { Badge, StatusBadge } from "@/components/StatusBadge";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Wallet, Eye, AlertCircle } from "lucide-react";

export default function CariTakip() {
  const navigate = useNavigate();
  const [companies, setCompanies] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    api.get("/companies").then((r) => setCompanies(r.data));
  }, []);

  const withDebt = companies.filter((c) => c.summary?.remaining_debt > 0);
  const overdue = companies.filter((c) => c.summary?.overdue_debt > 0);
  const filtered = q
    ? withDebt.filter((c) => c.company_name.toLowerCase().includes(q.toLowerCase()))
    : withDebt;

  const totalDebt = withDebt.reduce((s, c) => s + (c.summary?.remaining_debt || 0), 0);
  const totalOverdue = overdue.reduce((s, c) => s + (c.summary?.overdue_debt || 0), 0);

  return (
    <div className="space-y-4">
      <div className="grid md:grid-cols-3 gap-4">
        <div className="azd-card azd-stat-card p-5">
          <div className="text-[11px] uppercase tracking-wider text-[#6B7280] font-bold">
            Borçlu Firma
          </div>
          <div className="text-2xl font-extrabold text-[#08285A] mt-1">{withDebt.length}</div>
        </div>
        <div className="azd-card azd-stat-card azd-accent p-5">
          <div className="text-[11px] uppercase tracking-wider text-[#6B7280] font-bold">
            Toplam Kalan Borç
          </div>
          <div className="text-2xl font-extrabold text-[#08285A] mt-1">{fmtTL(totalDebt)}</div>
        </div>
        <div className="azd-card azd-stat-card azd-error p-5">
          <div className="text-[11px] uppercase tracking-wider text-[#6B7280] font-bold">
            Vadesi Geçmiş
          </div>
          <div className="text-2xl font-extrabold text-[#DC2626] mt-1">{fmtTL(totalOverdue)}</div>
        </div>
      </div>

      <div className="azd-card p-4 lg:p-5">
        <Input data-testid="cari-search" value={q} onChange={(e) => setQ(e.target.value)}
               placeholder="Firma ara..." />
      </div>

      <div className="azd-card overflow-hidden">
        <div className="overflow-x-auto azd-scrollbar">
          <table className="w-full text-sm">
            <thead className="bg-[#F6F8FB] text-[11px] uppercase tracking-wider text-[#6B7280]">
              <tr>
                <th className="text-left px-4 py-3 font-semibold">Firma</th>
                <th className="text-right px-4 py-3 font-semibold">Toplam Satış</th>
                <th className="text-right px-4 py-3 font-semibold">Ödenen</th>
                <th className="text-right px-4 py-3 font-semibold">Kalan Borç</th>
                <th className="text-right px-4 py-3 font-semibold">Gecikmiş</th>
                <th className="text-right px-4 py-3 font-semibold"></th>
              </tr>
            </thead>
            <tbody>
              {filtered.length === 0 ? (
                <tr><td colSpan={6} className="p-8 text-center text-[#6B7280]">Borçlu firma bulunmuyor</td></tr>
              ) : filtered.map((c) => (
                <tr key={c.id} className="border-t border-[#E5E7EB] hover:bg-[#F6F8FB]/50"
                    data-testid={`cari-row-${c.id}`}>
                  <td className="px-4 py-3 font-semibold text-[#111827]">{c.company_name}</td>
                  <td className="px-4 py-3 text-right">{fmtTL(c.summary?.total_sales)}</td>
                  <td className="px-4 py-3 text-right text-[#16A34A] font-semibold">{fmtTL(c.summary?.total_paid)}</td>
                  <td className="px-4 py-3 text-right font-bold text-[#0B3676]">{fmtTL(c.summary?.remaining_debt)}</td>
                  <td className="px-4 py-3 text-right">
                    {c.summary?.overdue_debt > 0 ? (
                      <span className="text-[#DC2626] font-bold">{fmtTL(c.summary.overdue_debt)}</span>
                    ) : "-"}
                  </td>
                  <td className="px-4 py-3 text-right">
                    <Button size="sm" variant="outline"
                            onClick={() => navigate(`/cari/movements?company=${c.id}`)}>
                      <Eye size={14} className="mr-1" /> Hareketler
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
